/**
 * WHAT ACTUALLY HAPPENS TO A SCREENPLAY.
 *
 * The design's notice read: "Your script stays private to this project's Owners
 * and Admins. It is never used to train AI models, and you can delete the
 * original at any time." All three clauses are untrue of this build, and a
 * privacy promise about somebody else's intellectual property is the last place
 * to write something aspirational:
 *
 *   - Owners and Admins were retired (ADR 0014). `READ_SCRIPT` is held by every
 *     production role by default; a production can narrow it per role, and the
 *     Team tab shows what it decided.
 *   - It IS used for training. ADR 0013 keeps a corpus of rendered prompts and
 *     raw model responses, and `corpus-export.service.ts` marks artefacts from
 *     the production environment `trainingEligible: true` — "Production
 *     environment — admitted by default." There is no per-project opt-out.
 *   - Nothing is deleted (ADR 0011): a file soft-deletes its row and RETAINS
 *     the object.
 *
 * So this says what is true. If the product wants to make the design's promise
 * instead, that is a change to the corpus and to retention, not to this string.
 */
const HOW_IT_IS_KEPT =
  'Your script is stored privately and is never published. Who on the production can open it ' +
  'is set by their role — a producer can narrow that under Team. We keep the original and what ' +
  'our models made of it, so a breakdown can be reproduced and improved; nothing is deleted.';

export function ScriptPrivacyNotice() {
  return (
    <div
      data-testid="script-privacy"
      style={{ marginTop: 18, padding: '14px 16px', border: '1px solid var(--color-divider)', background: 'var(--color-surface)' }}
    >
      <p className="mm" style={{ margin: 0, fontSize: 12.5, lineHeight: 1.7 }}>
        {HOW_IT_IS_KEPT}
      </p>
    </div>
  );
}
